import React, { useState } from "react";
import { Search, Filter, FilterX, X } from "lucide-react";
import styles from "./NotificationDrawer.module.scss";
import { useSelector } from "react-redux";
import { loading } from "../../store/selectors/general.selector";
import { Tooltip } from "@fluentui/react-components";

const NotificationHeader = (props) => {
  const isLoading = useSelector(loading);
  const { handleSearch, handleFilterUnread, headerBg, isFilterActive } = props;
  const [searchValue, setSearchValue] = useState("");

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    handleSearch(value);
  };

  const handleClear = () => {
    setSearchValue("");
    handleSearch("");
  };

  return (
    <div className={`${styles.notifyHeader} ${headerBg}`}>
      <div className={styles.searchWrapper}>
        <div className={styles.searchInputWrapper}>
          <Search className={styles.searchIcon} size={16} />
          <input
            type="text"
            className={styles.searchInput}
            placeholder="Search notifications..."
            value={searchValue}
            onChange={handleSearchChange}
            disabled={isLoading}
          />
          {searchValue && (
            <button className={styles.clearButton} onClick={handleClear}>
              <X size={16} />
            </button>
          )}
        </div>
      </div>
      <div className="d-flex align-items-center gap-2">
        <Tooltip 
          content={isFilterActive ? "Show all notifications" : "Show only unread"} 
          relationship="label"
        >
          <button
            className={`${styles.filterButton} ${isFilterActive ? styles.filterActive : ''}`}
            onClick={handleFilterUnread}
            disabled={isLoading}
          >
            {isFilterActive ? <FilterX size={16} /> : <Filter size={16} />}
          </button>
        </Tooltip>
      </div>
    </div>
  );
};

export default NotificationHeader;
